<template>
  <div class="vmp-reward-effect" v-if="showEffectStatus">
    <transition-group name="join-left-right">
      <div
        v-for="joinEffectInfo in joinRoomEffectList"
        v-bind:key="joinEffectInfo.id"
        class="join-effect-box"
      >
        <span class="join-nick-name">
          {{ joinEffectInfo.message }}
        </span>
      </div>
    </transition-group>
    <transition-group name="right-left">
      <div
        v-for="rewardEffectInfo in rewardEffectList"
        v-bind:key="rewardEffectInfo.msg_id"
        class="reward-effect-box default"
        :class="{
          // 打赏动效背景class
          'bg-red-package': rewardEffectInfo.data.type != 'gift_send_success',
          // 默认礼物的背景class
          [effectsMap[rewardEffectInfo.data.gift_name] || 'bg-custom']:
            rewardEffectInfo.data.type == 'gift_send_success'
        }"
      >
        <!-- <span class="money-img cover-img" v-if="rewardEffectInfo.type == 'reward'"></span> -->
        <img class="gift-user-avatar" :src="gift_user_avatar(rewardEffectInfo)" />
        <span class="nick-name">
          {{ gift_user_nickname(rewardEffectInfo) | overHidden(8) }}
        </span>
        <span
          class="gift-name"
          v-if="
            rewardEffectInfo.data.type == 'gift_send_success' ||
            rewardEffectInfo.data.event_type == 'free_gift_send'
          "
        >
          <!-- 礼物标题 -->
          {{ `${$t('chat.chat_1032')} ${$tdefault(rewardEffectInfo.data.gift_name)}` }}
        </span>
        <span class="gift-name" v-if="rewardEffectInfo.data.type == 'reward_pay_ok'">
          {{ rewardEffectInfo.data.reward_describe | overHidden(8) }}
        </span>
        <span
          v-if="
            rewardEffectInfo.data.type == 'gift_send_success' ||
            rewardEffectInfo.data.event_type == 'free_gift_send'
          "
          class="gift-img"
          :class="rewardEffectInfo.data.source_status == 1 ? 'zdy-gigt-img' : ''"
          :style="{
            backgroundImage: `url(${
              rewardEffectInfo.data.gift_image_url || rewardEffectInfo.data.gift_url
            }`
          }"
        ></span>
        <img
          :src="Sources.gift.reward"
          class="gift-img red-package"
          v-else-if="rewardEffectInfo.data.type == 'reward_pay_ok'"
        />
      </div>
    </transition-group>
  </div>
</template>

<script>
  import {
    useRoomBaseServer,
    useGiftsServer,
    useChatServer,
    useWatchRewardServer,
    useMenuServer,
    useMsgServer
  } from 'middle-domain';
  import TaskQueue from './taskQueue';
  import { getDefaultAvatar } from '@/app-shared/utils/ossImgConfig';
  import Sources from '@/app-shared/utils/sourceChange.js';
  import { throttle } from 'lodash';
  export default {
    name: 'VmpPcRewardEffect',
    data() {
      return {
        Sources,
        effectsMap: {
          鲜花: 'bg-flower',
          咖啡: 'bg-coffee',
          666: 'bg-666'
          // 'bg-custom': 'bg-custom' //用户自定义礼物
        },
        //是否屏蔽特效
        hideEffect: sessionStorage.getItem('filterStatus_isShieldingEffects') == 'true',
        hideJoinEffect: sessionStorage.getItem('filterStatus_isShieldingJoinEffects') == 'true',
        rewardEffectList: [],
        joinRoomEffectList: [],
        showEffectStatus: this.$route.query.assistantType ? true : false, //是否显示礼物动画, 如果当前tab为聊天时才显示
        taskQueue: null, // 飘窗列队
        joinEffectTimer: null, //加入房间效果的定时器
        defaultMessage: this.$t('host.k_604001')
      };
    },
    computed: {
      watchInitData() {
        return this.roomBaseServer.state.watchInitData;
      },
      // 默认用户头像
      default_user_avatar() {
        return getDefaultAvatar();
      },
      // 是否观看端
      isWatch() {
        return !['send', 'record', 'clientEmbed'].includes(this.roomBaseServer.state.clientType);
      },
      joinInfo() {
        return this.$domainStore.state.roomBaseServer.watchInitData.join_info;
      },
      welcome_message() {
        let welcome_message =
          this.$domainStore.state.roomBaseServer.permissionValueObj.welcome_message;
        welcome_message = welcome_message
          ? JSON.parse(welcome_message)
          : { status: 0, message: this.defaultMessage };
        // return text.replace(/\{user_nickname\}/g, replacement);
        return welcome_message;
      },

      isHideJoinEffect() {
        return this.isWatch ? this.hideEffect : this.hideJoinEffect;
      }
    },
    created() {
      this.roomBaseServer = useRoomBaseServer();
      this.watchRewardServer = useWatchRewardServer();
      this.giftsServer = useGiftsServer();
      this.chatServer = useChatServer();
      this.msgServer = useMsgServer();
      this.menuServer = useMenuServer();
      this.listenServer();

      if (this.menuServer.state.currentTab && this.menuServer.state.currentTab.type == 3) {
        this.showEffectStatus = true;
      } else {
        this.showEffectStatus = false;
      }
    },

    mounted() {
      /**
       * 初始化礼物动画队列
       */
      this.taskQueue = new TaskQueue({
        minTaskTime: 2000,
        maxQueueLen: 3
      });
      this.showJoinEffect({
        nickname: this.joinInfo?.nickname,
        id: this.joinInfo.third_party_user_id,
        role: this.joinInfo.role_name
      });
    },
    methods: {
      // 监听domain层服务消息
      listenServer() {
        this.msgServer.$onMsg('JOIN', msg => {
          console.log('收到JOIN消息:', msg);
          const joinMsg = {
            nickname: msg.context.nickname,
            id: msg.sender_id,
            role: msg.context.role_name
          };
          if (msg.sender_id == this.joinInfo.third_party_user_id) return;
          // 有新消息直接显示，顶掉当前显示的
          this.showJoinEffect(joinMsg);
        });
        this.giftsServer.$on('gift_send_success', msg => {
          console.log('VmpWapRewardEffect-------->', msg);
          let nickname = msg.data.gift_user_nickname || msg.data.nickname;
          // 增加昵称加密处理
          if (this.isWatch) {
            nickname = this.roomBaseServer.encryptNickname(nickname, msg.data.gift_user_id);
          }
          // 发送礼物昵称长度还是采用8个字符长度，否则影响展示效果
          const data = {
            nickname: nickname.length > 8 ? nickname.substr(0, 8) + '...' : nickname,
            avatar: msg.data.avatar,
            content: {
              gift_name: msg.data.gift_name,
              gift_url: `${msg.data.gift_image_url || msg.data.gift_url}`,
              source_status: msg.data.source_status
            },
            type: 'gift_send_success',
            roleName: 2,
            interactToolsStatus: true
          };
          this.chatServer.addChatToList(data);
          !this.hideEffect && this.addRewardEffect(msg);
        });
        // 打赏消息
        this.watchRewardServer.$on('reward_pay_ok', rawMsg => {
          // 添加聊天消息
          const data = {
            avatar: rawMsg.data.rewarder_avatar,
            nickname:
              rawMsg.data.rewarder_nickname.length > 8
                ? rawMsg.data.rewarder_nickname.substr(0, 8) + '...'
                : rawMsg.data.rewarder_nickname,
            type: 'reward_pay_ok',
            content: {
              text_content: rawMsg.data.reward_describe
                ? rawMsg.data.reward_describe
                : this.$t('chat.chat_1037'),
              num: rawMsg.data.reward_amount
            },
            sendId: this.roomBaseServer.state.watchInitData.join_info.third_party_user_id,
            roleName: this.roleName,
            interactToolsStatus: true
          };
          this.chatServer.addChatToList(data);
          !this.hideEffect && this.addRewardEffect(rawMsg);

          if (
            this.roomBaseServer.state.watchInitData.join_info.third_party_user_id ==
            rawMsg.data.rewarder_id
          ) {
            this.$message({
              message: this.$t('common.common_1005'),
              showClose: true,
              // duration: 0,
              type: 'success',
              customClass: 'zdy-info-box'
            });
          }
        });
        // 自定义菜单服务事件监听
        this.menuServer.$on('tab-switched', data => {
          console.log('reward-effect tab-switched------>', this.cuid, data);
          /**
           * { cuid, menuId }
           * 如果当前tab 激活的是聊天
           */
          if (this.cuid == 'comPcRewardEffect' && data.type == 3) {
            this.showEffectStatus = true;
          } else {
            this.showEffectStatus = false;
          }
        });
      },
      // 显示加入房间效果
      showJoinEffect: throttle(
        function (joinMsg) {
          // 清除之前的定时器，防止多个定时器同时运行
          if (this.isHideJoinEffect || this.welcome_message.status != 1 || joinMsg.role != 2) {
            return;
          }
          if (this.joinEffectTimer) {
            clearTimeout(this.joinEffectTimer);
          }
          const nickname = this.join_user_nickname(joinMsg);
          // 清除之前的定时器，防止多个定时器同时运行
          if (this.welcome_message.message == this.defaultMessage) {
            joinMsg.message = this.$t('chat.chat_1111', { n: nickname });
          } else {
            joinMsg.message = this.welcome_message.message.replace(/\{user_nickname\}/g, nickname);
          }
          // 添加动画效果
          this.joinRoomEffectList = [joinMsg];

          // 3秒后移除效果
          this.joinEffectTimer = setTimeout(() => {
            this.joinRoomEffectList = [];
          }, 3000);
        },
        1000,
        { trailing: false }
      ),

      // 礼物用户头像
      gift_user_avatar(rewardEffectInfo) {
        console.log('gift_user_avatar------>', rewardEffectInfo);
        if (
          rewardEffectInfo.data.type == 'gift_send_success' ||
          rewardEffectInfo.data.type == 'reward_pay_ok' ||
          rewardEffectInfo.data.event_type == 'free_gift_send'
        ) {
          // 来源于接口消息字段
          if (rewardEffectInfo.data.avatar) {
            return rewardEffectInfo.data.avatar;
          } else if (rewardEffectInfo.data.gift_user_avatar) {
            return rewardEffectInfo.data.gift_user_avatar;
          } else if (rewardEffectInfo.data.rewarder_avatar) {
            return rewardEffectInfo.data.rewarder_avatar;
          } else {
            return this.default_user_avatar;
          }
        } else {
          return this.default_user_avatar;
        }
      },
      // 用户昵称
      gift_user_nickname(rewardEffectInfo) {
        let nickname = '';
        if (
          rewardEffectInfo.data.type == 'gift_send_success' ||
          rewardEffectInfo.data.type == 'reward_pay_ok' ||
          rewardEffectInfo.data.event_type == 'free_gift_send'
        ) {
          if (rewardEffectInfo.data.gift_user_nickname) {
            nickname = rewardEffectInfo.data.gift_user_nickname;
          } else if (rewardEffectInfo.data.rewarder_nickname) {
            nickname = rewardEffectInfo.data.rewarder_nickname;
          } else {
            // 默认返回nickname
            nickname = rewardEffectInfo.data.nickname;
          }
        } else {
          nickname = rewardEffectInfo.data.nickname;
        }
        // 增加昵称加密处理
        if (this.isWatch) {
          nickname = this.roomBaseServer.encryptNickname(
            nickname,
            rewardEffectInfo.data.gift_user_id
          );
        }
        return nickname;
      },
      //设置是否屏蔽特效
      setHideEffect(status) {
        this.hideEffect = status;
      },
      setHideJoinEffect(status) {
        this.hideJoinEffect = status;
      },
      /**
       * 根据消息里的sender_id判断, 是否是自己发送的
       */
      isSelfByMsgSenderId(sender_id) {
        if (this.watchInitData.join_info.third_party_user_id == sender_id) {
          return true;
        } else {
          return false;
        }
      },
      /**
       * 开始播放效果
       */
      playRewardEffect(effect) {
        return new Promise(resolve => {
          this.rewardEffectList.push(effect);
          this.$nextTick(() => {
            resolve();
          });
        });
      },
      /**
       * 移除对应的效果
       */
      removeRewardEffect(effect) {
        return new Promise(resolve => {
          console.log('removeRewardEffect-------->', effect.msg_id);
          this.rewardEffectList.splice(0, 1);
          this.$nextTick(() => {
            resolve();
          });
        });
      },
      addRewardEffect(msg) {
        // 添加到队列
        this.taskQueue.addTask({
          gift_price: msg.data.gift_price,
          isSelf: this.isSelfByMsgSenderId(msg.sender_id),
          playRewardEffect: this.playRewardEffect.bind(this, msg),
          removeRewardEffect: this.removeRewardEffect.bind(this, msg)
        });
      },
      // 加入用户昵称
      join_user_nickname(joinEffectInfo) {
        let nickname = joinEffectInfo.nickname || '';
        // 增加昵称加密处理
        if (this.isWatch) {
          nickname = this.roomBaseServer.encryptNickname(nickname, joinEffectInfo.id);
        }
        return nickname.substring(0, 10);
      }
    },
    destroy() {
      console.log('VmpWapRewardEffect 组件销毁');
    }
  };
</script>

<style lang="less">
  // 飘屏
  .vmp-reward-effect {
    position: absolute;
    overflow: hidden;
    padding-top: 8px;
    left: 16px;
    top: 45px;
    z-index: 100;
    // 加入房间动效样式
    .join-effect-box {
      background: linear-gradient(
        90deg,
        var(--theme-color-main) 0%,
        var(--theme-welcome-greeting-bg) 100%
      );
      box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
      border-radius: 100px;
      color: #ffffff;
      font-size: 14px;
      line-height: 20px;
      padding: 6px 16px;
      text-shadow: 0 2px 2px rgba(0, 0, 0, 0.1);
      text-align: center;
      .join-nick-name {
        font-size: 14px;
        color: #ffffff;
        margin-right: 8px;
      }
    }
    // 从左向右滑入动画，淡出消失
    .join-left-right-enter-active {
      transition: all 0.3s ease-in-out;
    }
    .join-left-right-leave-active {
      transition: opacity 0.1s ease-in-out;
    }
    .join-left-right-enter {
      transform: translateX(-100%);
      opacity: 0;
    }
    .join-left-right-enter-to {
      transform: translateX(0);
      opacity: 1;
    }
    .join-left-right-leave-to {
      transform: translateX(0);
      opacity: 0;
    }
    .reward-effect-box {
      width: 234px;
      height: 54px;
      position: relative;
      background-size: 100%;
      background-repeat: no-repeat;
      &.default {
        background-image: url(images/red-package-bg.png);
      }
      &.bg-coffee {
        background-image: url(images/coffee-bg.png);
      }
      &.bg-custom {
        background-image: url(images/custom-bg.png);
      }
      &.bg-flower {
        background-image: url(images/flower-bg.png);
      }
      &.bg-666 {
        background-image: url(images/666-bg.png);
      }
      .gift-user-avatar {
        width: 40px;
        height: 40px;
        position: absolute;
        left: 4px;
        bottom: 4px;
        border-radius: 50%;
        overflow: hidden;
      }
    }
    .money-img {
      display: inline-block;
      width: 50px;
      height: 50px;
      background-image: url('images/reward-chat.png');
    }

    .gift-img {
      width: 78px;
      height: 56px;
      position: absolute;
      right: 0;
      bottom: 0px;
      background-repeat: no-repeat;
      background-position: center;
      background-size: contain;
      z-index: 10;
    }
    .zdy-gigt-img {
      width: 42px;
      height: 42px;
      background-color: white;
      border-radius: 50%;
    }
    .nick-name {
      width: 252px;
      height: 28px;
      font-size: 14px;
      // font-weight: 500;
      color: #ffffff;
      line-height: 28px;
      position: absolute;
      top: 7px;
      left: 55px;
    }
    .gift-name {
      width: 216px;
      height: 24px;
      font-size: 14px;
      color: #ffffff;
      line-height: 24px;
      position: absolute;
      top: 27px;
      left: 55px;
      opacity: 0.8;
      // .ellipsis();
      // .ellipsis {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      // }
    }
    .money,
    .count {
      color: #ffd63b;
    }
    .multiple {
      font-size: 12px;
    }
    .red-package {
      width: 32px;
      height: auto;
      top: -2px;
      right: 16px;
    }
  }
</style>
